import { MODAL_VERTICAL_OFFSET } from '../../../components/Modals/modalConstants';

export const FULL_MEDIA_MODAL_WIDTH = '96vw';

// Floor for the portrait video modal's computed width, so extreme aspect
// ratios (e.g. a sideways-recorded clip) don't render controls unusably
// cramped. Still capped by maxWidth below, so it never overflows the viewport.
const MIN_PORTRAIT_VIDEO_MODAL_WIDTH = 320;

export const getVideoModalWidth = (aspectRatio: number | null) => {
  if (!aspectRatio || aspectRatio >= 1) {
    return FULL_MEDIA_MODAL_WIDTH;
  }

  const availableHeight = window.innerHeight - MODAL_VERTICAL_OFFSET;
  const maxWidth = window.innerWidth * 0.9;
  const portraitWidth = Math.round(availableHeight * aspectRatio);
  const clampedWidth = Math.max(MIN_PORTRAIT_VIDEO_MODAL_WIDTH, portraitWidth);

  return `${Math.min(clampedWidth, maxWidth)}px`;
};
